module.exports = __webpack_public_path__ + "static/media/screen2.ecf224cf.png";